import React from 'react';
import AppButton from './AppButton';
import './ConfirmRedirect.scss';
import UtilService from "../services/UtilService";
import AuthorityToLeave from './AuthorityToLeave';

export default function ConfirmRedirect(props) {
    return (
        <div className="additional-services">
            <div>
                <div className="view-body">
                    <div className="form-group">
                        <label>Your new delivery address</label>
                        <div className="fakeinput">
                            <div>{props.to.Address.Name}</div>
                            <div>{props.to.Address.Address1}</div>
                            <div>{props.to.Address.Address2}</div>
                            <div>{props.to.Address.suburb.name}</div>
                            <div>{props.to.Instruction}</div>
                        </div>
                    </div>
                    <AuthorityToLeave readonly shipment={props.shipment} offer={props.offer} config={props.config}></AuthorityToLeave>
                    <div className="form-group">
                        <label>New delivery contact</label>
                        <div className="fakeinput">
                            <div>{props.to.Contact.Name}</div>
                            <div>{props.to.Contact.Mobile}</div>
                            <div>{props.to.Contact.Email}</div>
                        </div>
                    </div>
                    {(props.costs && props.costs.length > 0 && props.redirectPrice() > 0) && 
                    <React.Fragment>
                        <div style={{marginTop: "0.4em"}} />
                        <div>
                            <div className="header">Redirection Costs</div>
                            <table className="services">
                                <tbody>
                                    {props.costs.map((as) => 
                                        <tr key={as.code}>
                                            <td style={{width: "100%"}}>{as.description}</td>
                                            <td>{(as.priceInclGST && `$${UtilService.roundMoneyTo(parseFloat(as.priceInclGST), 2)}`)}</td>
                                        </tr>)}
                                </tbody>
                            </table>
                        </div>
                    </React.Fragment>}
                    {(props.services && props.services.length > 0) && 
                    <React.Fragment>
                        <div style={{marginTop: "0.4em"}} />
                        <div>
                            <div className="header">Additional Services</div>                        
                            <table className="services">
                                <tbody>
                                    {props.services.map((as) => 
                                        <tr key={as.code}>
                                            <td><input type="checkbox" className="large" defaultChecked={as.selected} disabled={as.paid || as.justpaid || as.paid_by === "S" || as.paid_by === "R"} onClick={() => props.changeAdditionalService(as.code)}/></td>
                                            <td style={{width: "100%"}}>{as.description}</td>
                                            <td>{props.isReceiverPrice(as) && (`$${UtilService.roundMoneyTo(parseFloat(as.priceInclGST), 2)}`)}</td>
                                        </tr>)}                                        
                                </tbody>
                            </table>
                        </div>
                    </React.Fragment>}
                    <table className="services">
                        <tbody><tr>
                            <td className="tcsCheck"><input type="checkbox" className="large" defaultChecked={props.acceptTerms}  onClick={() => props.toggleTCs()}/></td>
                            <td className="tcsLink">
                                Acceptance of <a style={{whiteSpace: "nowrap"}} href={props.config.termsAndConditions.additionalServicesUrl} target="_blank">Terms &amp; Conditions</a>
                                <div className="contactus"><a target="_blank" href={props.config.contactUsUrl}>{props.config.contactUsText}</a></div>
                            </td>
                        </tr></tbody>
                    </table>
                    {props.totalPrice() !== "$0.00" &&
                    <div>
                        <div className="header">Total Price (incl. GST)<div style={{float: "right"}}>{props.totalPrice()}&nbsp;</div></div>
                    </div>}
                    <div>                            
                        <div className="action-area">
                            <div className="clearfix">
                                {props.totalPrice() !== "$0.00" ?
                                    <AppButton ajaxInProgress={props.busy}  iconName="icon-button-credit-card" footer="Tap here to proceed to payment" actionText="Pay Now" onClick={props.startPayment}/> :
                                    <AppButton ajaxInProgress={props.busy}  iconName="icon-button-tick" footer="Tap here to confirm redirection details" actionText="Confirm" onClick={props.startPayment}/>}
                                <AppButton function iconName="icon-function-left-arrow-up" actionText="Back" 
                                    onClick={props.onBack} footer="Return to new address details"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );    
}
